<div class="toast-container position-fixed translate-middle-x start-50 mt-3">
  @for (toast of toastService.toasts; track toast) {
    <ngb-toast
      class="w-100"
      [class]="toast.cssClass"
      [autohide]="toast.keepOpen ? false : true"
      [delay]="toast.delay || 5000"
      (hidden)="hide(toast)">
      @if (isTemplate(toast)) {
        <ng-template [ngTemplateOutlet]="toast.textOrTpl" />
      } @else {
        @if (toast.showCloseButton) {
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        }
        <span [innerHTML]="toast.textOrTpl"></span>
      }
    </ngb-toast>
  }
</div>
